"use client";
/*
 * Documentation:
 * PRINT_DC_Card_IconText — https://app.subframe.com/4f62853ee923/library?component=PRINT_DC_Card_IconText_baad356d-87df-4e49-991f-a9f5e67ef667
 */

import React from "react";
import { FeatherShapes } from "@subframe/core";
import * as SubframeCore from "@subframe/core";
import * as SubframeUtils from "../utils";

interface Print_Dc_Card_IconTextRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  isMarginal?: boolean;
  icon?: React.ReactNode;
  hasHeadline?: boolean;
  headline?: React.ReactNode;
  text?: React.ReactNode;
  className?: string;
}

const Print_Dc_Card_IconTextRoot = React.forwardRef<
  HTMLDivElement,
  Print_Dc_Card_IconTextRootProps
>(function Print_Dc_Card_IconTextRoot(
  {
    isMarginal = false,
    icon = <FeatherShapes />,
    hasHeadline = false,
    headline,
    text,
    className,
    ...otherProps
  }: Print_Dc_Card_IconTextRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "group/baad356d flex w-full flex-col items-start gap-2 rounded-md",
        {
          "flex-col flex-nowrap gap-4": hasHeadline,
          "flex-col flex-nowrap gap-4 px-4 py-4": isMarginal,
        },
        className
      )}
      ref={ref}
      {...otherProps}
    >
      <div
        className={SubframeUtils.twClassNames(
          "flex w-full items-center gap-2",
          { "flex-row flex-nowrap gap-2": hasHeadline }
        )}
      >
        {icon ? (
          <SubframeCore.IconWrapper
            className={SubframeUtils.twClassNames(
              "text-heading-3 font-heading-3 text-subtext-color",
              { "text-body font-body": isMarginal }
            )}
          >
            {icon}
          </SubframeCore.IconWrapper>
        ) : null}
        {headline ? (
          <span
            className={SubframeUtils.twClassNames(
              "grow shrink-0 basis-0 text-body-bold font-body-bold text-subtext-color",
              {
                inline: hasHeadline,
                "text-caption-bold font-caption-bold": isMarginal,
              }
            )}
          >
            {headline}
          </span>
        ) : null}
      </div>
      {text ? (
        <span
          className={SubframeUtils.twClassNames(
            "w-full text-body font-body text-default-font",
            { "text-caption font-caption": isMarginal }
          )}
        >
          {text}
        </span>
      ) : null}
    </div>
  );
});

export const Print_Dc_Card_IconText = Print_Dc_Card_IconTextRoot;
